
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface InsuranceClaimsProps {
  locationName: string;
  email: string;
  phone: string;
}

const InsuranceClaims: React.FC<InsuranceClaimsProps> = ({ locationName, email, phone }) => {
  const insurancePartners = [
    "State Farm, Allstate, USAA, Farmers Insurance",
    "North Carolina Farm Bureau Insurance",
    "Nationwide, Progressive, Liberty Mutual",
    "Regional carriers serving rural Nash and Edgecombe Counties",
    "Commercial insurance specialists"
  ];

  const claimsSupport = [
    "Initial damage assessment and documentation",
    "Detailed photo and video evidence collection",
    "Insurance company communication and negotiation",
    "Supplemental claims processing for hidden damage",
    "Direct billing arrangements when available"
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6">Insurance Claims Expertise</h2>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">Dedicated Claims Department</CardTitle>
          <div className="text-lg">
            <p><strong>Email:</strong> {email}</p>
            <p><strong>Phone:</strong> {phone}</p>
          </div>
        </CardHeader>
        <CardContent>
          <p className="mb-6">
            Our {locationName} office features a dedicated insurance claims department that works directly with all major carriers serving North Central North Carolina.
          </p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-bold mb-3">Insurance Partners:</h3>
              <ul className="space-y-1">
                {insurancePartners.map((partner, index) => (
                  <li key={index}>• {partner}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-bold mb-3">Claims Process Support:</h3>
              <ul className="space-y-1">
                {claimsSupport.map((support, index) => (
                  <li key={index}>• {support}</li>
                ))}
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default InsuranceClaims;
